import { GridColDef } from "@mui/x-data-grid-premium";
import PatMonitoringExampleRows from "../model";
import WoundAssessCreate from "../create";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//CKAPISIZ;456269;18042025; EKLE VE SIL BUTONLARI GUNCELLENDI
const columns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return <ByzGrdEditButton link={`edit/${params.row.id}`} />;
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field0", headerName: "Kullanıcı", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <ByzGrdDeleteButton onClick={() => console.log(params.row.id)} />
    ),
  },
];

function WoundAssessList() {
  return (
    <BaseMedCardList
      title="Yara Değerlendirme"
      columns={columns}
      rows={PatMonitoringExampleRows}
      CreateComponent={WoundAssessCreate}
      pageSize={10}
    />
  );
}

export default WoundAssessList;
